import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@mui/material';

type Props = Pick<
  MuiMenuItemProps,
  | 'onClick'
  | 'onKeyUp'
  | 'onMouseEnter'
  | 'onMouseLeave'
  | 'children'
  | 'className'
  | 'sx'
  | 'disabled'
  | 'selected'
  | 'value'
  | 'role'
  | 'tabIndex'
  | 'autoFocus'
  | 'aria-label'
  | 'aria-disabled'
  | 'aria-selected'
> & {
  testId?: string;
  'data-value'?: unknown;
};

const MenuItem = ({
  children,
  onClick,
  onKeyUp,
  onMouseEnter,
  onMouseLeave,
  className,
  sx,
  disabled,
  selected,
  value,
  role,
  tabIndex,
  autoFocus,
  testId,
  'aria-label': ariaLabel,
  'aria-disabled': ariaDisabled,
  'aria-selected': ariaSelected,
  'data-value': dataValue,
}: Props) => {
  return (
    <MuiMenuItem
      disableGutters
      className={className}
      sx={sx}
      disabled={disabled}
      selected={selected}
      value={value}
      role={role}
      tabIndex={tabIndex}
      autoFocus={autoFocus}
      aria-label={ariaLabel}
      aria-disabled={ariaDisabled ?? (disabled || undefined)}
      aria-selected={ariaSelected}
      data-value={dataValue}
      test-id={testId}
      onClick={onClick}
      onKeyUp={onKeyUp}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </MuiMenuItem>
  );
};

export default MenuItem;
